<template>
    <div class="user-menu">
		<div class="user-menu__main">
			<router-link class="user-menu__rang" v-if="user.rang" :to="{name: 'rang'}">
				<img class="user-menu__rang-icon" :src="user.rang.icon_url"/>
			</router-link>
			<router-link :to="{name: 'settings'}" class="header__user-info">
				<div class="header__user-name"> {{ user.username }} </div>
				<div v-show="hideBalance" class="header__user-balance"> В игре </div>
				<div v-show="!hideBalance" :mybalance="user.balance.toFixed(2)" class="odometer header__user-balance" id="userBalance">
					{{ user.balance.toFixed(2) }}
				</div>
			</router-link>
		</div>
		<div class="user-menu__buttons">
			<button @click="showDeposit" class="btn btn--sm btn--primary-alt btn--block user-menu__button">
				Пополнить
			</button>
			<router-link :to="{'name': 'withdraw'}" class="btn btn--sm btn--primary-alt btn--block user-menu__button">
				Вывести
			</router-link>
		</div>
    </div>
</template>

<script>
	import { useUserStore } from '../../stores/User';
	import {mapState} from "pinia";

    export default {
		computed: {
			...mapState(useUserStore, ['user']),

			hideBalance() {
				return ['slotsGame'].includes(this.$route.name);
			},

			page() {
				return this.$route.name;
			}
		},

		methods: {
			showDeposit() {
				this.$root.emitter.emit('openDeposit');
			}
		}
    }
</script>
